export default __webpack_public_path__ + "static/media/long-road-ahead.087ef5d4.svg";